export function scrollToTop() {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
}

export function scrollToSection(id, block = 'start') {
    const element = document.getElementById(id);
    if (element) element.scrollIntoView({ behavior: 'smooth', block });
}

export function bodyScrollLock() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('noscroll');
}

export function removeBodyScrollLock() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('noscroll');
}

export function getModalPositioning(id, ms = 50) {
    setTimeout(() => {
        const windowHeight = window.innerHeight;
        const modal = document.getElementById(id);
        if (!modal) return;
        const modalHeight = modal.offsetHeight;

        const modalContainer = document.getElementsByClassName('popup-container visible')[0];

        if (modalHeight < windowHeight) {
            modal.classList.add('popup-open');
            modal.classList.remove('popup-open-small');
            modalContainer.setAttribute('style', 'overflow: hidden ');
        } else {
            modalContainer.removeAttribute('style');
            modal.classList.remove('popup-open');
            modal.classList.add('popup-open-small');
        }
    }, ms);
}

export function replaceInString(str, obj) {
    const regexp = /{([^{]+)}/g;
    return str.replace(regexp, (ignore, key) => {
        return (key = obj[key]) == null ? '' : key;
    });
}

export function isObjectEmpty(obj) {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
}

export function isObjectNullOrEmpty(obj) {
    if (obj == null) return true;
    return isObjectEmpty(obj);
}

export function stripHtml(html) {
    const virtualDom = document.createElement('DIV');
    virtualDom.innerHTML = html;
    return virtualDom.textContent || virtualDom.innerText || '';
}

export function dateFormatter(event) {
    if (!event) return;
    const input = document.getElementById(event.currentTarget.id);
    const value = input.value;
    const length = value.length;

    if ((event.code === 'Backspace' || event.key === 'Backspace') && (length === 2 || length === 5)) input.value = value.substring(0, length-1);
    else if (event.code === 'Period' || event.key === '.' || event.keyCode === 229) input.value = value.substr(0, length-1);
    else if (length === 2 || length === 5) input.value = `${value}.`;
}
